export const preloadImages = (...urls) => {
  return new Promise(resolve => {
    const images = urls.filter(Boolean).map(url => {
      const img = new Image();
      img.src = url;
      return img;
    });

    let loadedCount = 0;
    images.forEach(img => {
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) resolve();
      };
      img.onerror = () => {
        loadedCount++;
        console.error(`Failed to preload image: ${img.src}`);
        if (loadedCount === images.length) resolve();
      };
    });
  });
};
